import { useQueryClient } from "@tanstack/react-query";

import { getGetDealProspectsPermissionViewQueryKey } from "@vega-api/generated/coinvest-deal-permission/coinvest-deal-permission";
import { getGetDealShortlistQueryKey } from "@vega-api/generated/coinvest-deal-shortlist/coinvest-deal-shortlist";
import { getGetDealTeaserEmailsSummaryV2QueryKey } from "@vega-api/generated/coinvest-deal-teaser-email-v2/coinvest-deal-teaser-email-v2";
import { NotificationContentType } from "@vega-api/generated/types/notificationContentType";
import { useNotificationEvent } from "@vega-modules/scenes/Notifications/useNotificationEvent";

export const useOutreachSentLiveRefresh = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const queryClient = useQueryClient();

  useNotificationEvent(
    NotificationContentType.COINVEST_EVENT_TEASER_EMAIL_UPDATE,
    (payload) => {
      const dealId = payload.meta.dealId;

      if (!enabled || !dealId) return;

      queryClient.invalidateQueries({
        queryKey: getGetDealShortlistQueryKey(dealId),
      });
      queryClient.invalidateQueries({
        queryKey: getGetDealTeaserEmailsSummaryV2QueryKey(dealId),
      });
      queryClient.invalidateQueries({
        queryKey: getGetDealProspectsPermissionViewQueryKey(dealId),
      });
    },
  );
};
